/**
 * Copia texto para a área de transferência USANDO O DOCUMENTO ONDE O CLIQUE ACONTECEU.
 *
 * Com a sala na janela flutuante (outro documento), o `navigator.clipboard` da guia não serve: quem tem
 * o foco e o gesto do usuário é a janela flutuante, e o navegador recusa a escrita do documento sem
 * foco ("Document is not focused"). Por isso a escrita usa o `navigator` da janela do documento dado e,
 * se a API for recusada ou não existir (contexto inseguro, navegador antigo), cai no
 * `execCommand('copy')` com um campo temporário DESSE mesmo documento.
 *
 * @param {string} text
 * @param {Document} [doc] documento do elemento clicado (`event.currentTarget.ownerDocument`)
 * @returns {Promise<boolean>} se copiou
 */
export async function copyToClipboard(text, doc = globalThis.document) {
    const win = doc?.defaultView ?? globalThis.window;
    try {
        await win.navigator.clipboard.writeText(text);
        return true;
    } catch {
        return copyWithSelection(text, doc);
    }
}

/** Plano B: seleciona um campo temporário e usa o comando antigo de cópia. */
function copyWithSelection(text, doc) {
    if (!doc?.body || typeof doc.execCommand !== 'function') return false;
    const field = doc.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.setAttribute('aria-hidden', 'true');
    Object.assign(field.style, { position: 'fixed', top: '0', left: '0', opacity: '0', pointerEvents: 'none' });
    doc.body.appendChild(field);
    try {
        field.select();
        field.setSelectionRange(0, text.length);
        return Boolean(doc.execCommand('copy'));
    } catch {
        return false;
    } finally {
        field.remove();
    }
}
